import { render, staticRenderFns } from "./ProfileIndexPage.vue?vue&type=template&id=195dc035&scoped=true"
import script from "./ProfileIndexPage.vue?vue&type=script&lang=ts"
export * from "./ProfileIndexPage.vue?vue&type=script&lang=ts"
import style0 from "./ProfileIndexPage.vue?vue&type=style&index=0&id=195dc035&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195dc035",
  null
  
)

export default component.exports